(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logy-mega-full-size-mascara"] && !Shopify.designMode) return;
  try {
    
(() => {
  const roots = document.querySelectorAll('.mfs');
  if (!roots.length) return;
  roots.forEach(root => {
    const productHandle = root.dataset.productHandle;
    const offers = [...root.querySelectorAll('.mfs__offer')];
    const status = root.querySelector('[data-form-status]');
    const money = value => '$' + Number(value).toLocaleString('es-CO') + ' COP';
    let selection = offers[0];
    let formReady = typeof window.__fsjOpenOrder === 'function' && window.__fsjOffers?.productHandle === productHandle;
    const update = option => {
      if (!option || option.hidden) return;
      selection = option;
      offers.forEach(item => { const active = item === option; item.classList.toggle('is-selected', active); item.setAttribute('aria-checked', String(active)); });
      const price = Number(option.dataset.price);
      const qty = Number(option.dataset.quantity);
      root.querySelector('[data-total]').textContent = money(price);
      root.querySelector('[data-selected-qty]').textContent = qty + (qty === 1 ? ' unidad seleccionada' : ' unidades seleccionadas');
      root.querySelector('[data-sticky-total]').textContent = money(price);
      root.querySelector('[data-sticky-qty]').textContent = qty + (qty === 1 ? ' unidad' : ' unidades');
      offers.forEach(item => {
        const saving = item.querySelector('em');
        if (!saving) return;
        const unit = Number(offers.find(offer => Number(offer.dataset.quantity) === 1)?.dataset.price || 0);
        const amount = Math.max(0, unit * Number(item.dataset.quantity) - Number(item.dataset.price));
        saving.textContent = amount ? 'Ahorra ' + money(amount) : '';
        saving.hidden = !amount;
      });
    };
    const syncOffers = detail => {
      if (!detail || detail.productHandle !== productHandle || !Array.isArray(detail.offers)) return;
      const liveOffers = detail.offers;
      offers.forEach(item => {
        const live = liveOffers.find(offer => Number(offer.quantity) === Number(item.dataset.quantity));
        item.hidden = !live;
        if (!live) return;
        item.dataset.price = String(Number(live.fixedTotal || live.price || 0));
        const amount = item.querySelector('strong');
        if (amount) amount.textContent = live.formattedPrice || money(item.dataset.price);
      });
      const next = offers.find(item => Number(item.dataset.quantity) === Number(selection?.dataset.quantity) && !item.hidden) || offers.find(item => !item.hidden);
      if (next) update(next);
    };
    offers.forEach((item, index) => {
      item.addEventListener('click', () => update(item));
      item.addEventListener('keydown', event => { if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return; event.preventDefault(); const visible = offers.filter(offer => !offer.hidden); const current = visible.indexOf(item); const next = visible[(current + (event.key === 'ArrowDown' ? 1 : visible.length - 1)) % visible.length]; update(next); next.focus(); });
    });
    root.querySelectorAll('[data-order]').forEach(button => button.addEventListener('click', () => {
      if (formReady && typeof window.__fsjOpenOrder === 'function') {
        window.__fsjOpenOrder({ productHandle, quantity: Number(selection.dataset.quantity) });
        status.hidden = true;
      } else {
        status.textContent = 'Mi formulario estará disponible cuando se conecte esta ficha de producto.';
        status.hidden = false;
      }
    }));
    window.addEventListener('fsj:ready', event => {
      if (event.detail?.productHandle !== productHandle) return;
      formReady = typeof window.__fsjOpenOrder === 'function';
      if (formReady) status.hidden = true;
    });
    window.addEventListener('fsj:offers', event => syncOffers(event.detail));
    syncOffers(window.__fsjOffers);
    update(selection);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
